import type { ValidationIssue } from '../../../Model/Order/ValidationIssue.js'
import {
  isOrderAlreadySubmitted,
  isSampleConfigurationSwitchRefused,
  isUnsupportedProcessingTypeForPlatform
} from '../../../Model/Order/ValidationIssue.js'

/** An order write answered 409: the order changed since it was loaded, whatever the edit was about. */
export const isOrderVersionConflict = (error: unknown): boolean => (error as { status?: number } | null)?.status === 409

export const ORDER_VERSION_CONFLICT_MESSAGE = 'The order was changed in the meantime. Reload the page and try again.'

/**
 * The backend's own reasons for refusing an order edit, sent as the same typed issue list a refused
 * submission carries. Null when the response has none, so callers can fall back to their own explanation.
 */
export const describeOrderWriteRefusal = (error: unknown): string | null => {
  const body = (error as { response?: unknown } | null)?.response
  if (!Array.isArray(body)) return null
  const messages = (body as ValidationIssue[])
    .filter((issue) => isSampleConfigurationSwitchRefused(issue) || isUnsupportedProcessingTypeForPlatform(issue) || isOrderAlreadySubmitted(issue))
    .map((issue) => issue.issue)
  return messages.length > 0 ? messages.join('\n') : null
}
